(function () {
  'use strict';

  function initAccordionReadMore(scope = document) {
    const accordionItems = Array.from(scope.querySelectorAll('[data-acc-item]')).filter(function (item) {
      return item.querySelector('[data-readmore-content]') && item.querySelector('[data-readmore]');
    });

    if (!accordionItems.length) return;

    const MOBILE_BREAKPOINT = 544;
    const MAX_HEIGHT_DESKTOP = 250;
    const MAX_HEIGHT_MOBILE = 300;

    function getMaxHeight() {
      return window.innerWidth <= MOBILE_BREAKPOINT ? MAX_HEIGHT_MOBILE : MAX_HEIGHT_DESKTOP;
    }

    function setupItem(item) {
      const content = item.querySelector('[data-readmore-content]');
      const button = item.querySelector('[data-readmore]');
      if (!content || !button) return;

      const textNode = button.querySelector('.pdp-accordion__readmore-text');
      const showMoreText = button.dataset.showMore || 'Mehr anzeigen';
      const showLessText = button.dataset.showLess || 'Weniger anzeigen';

      content.style.height = 'auto';
      content.classList.remove('is-collapsed', 'is-expanded');
      button.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');

      const maxHeight = getMaxHeight();
      const fullHeight = content.scrollHeight;

      if (fullHeight <= maxHeight) {
        button.hidden = true;
        content.style.height = 'auto';
        if (textNode) textNode.textContent = showMoreText;
        return;
      }

      button.hidden = false;

      const isExpanded = item.dataset.readmoreExpanded === 'true';

      if (isExpanded) {
        content.style.height = fullHeight + 'px';
        content.classList.add('is-expanded');
        button.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        if (textNode) textNode.textContent = showLessText;
      } else {
        content.style.height = maxHeight + 'px';
        content.classList.add('is-collapsed');
        button.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        if (textNode) textNode.textContent = showMoreText;
      }

      if (button.dataset.readmoreBound === 'true') return;

      button.addEventListener('click', function () {
        const expandedNow = item.dataset.readmoreExpanded === 'true';
        const currentFullHeight = content.scrollHeight;
        const currentMaxHeight = getMaxHeight();

        if (expandedNow) {
          item.dataset.readmoreExpanded = 'false';
          content.style.height = currentMaxHeight + 'px';
          content.classList.remove('is-expanded');
          content.classList.add('is-collapsed');
          button.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
          if (textNode) textNode.textContent = showMoreText;
        } else {
          item.dataset.readmoreExpanded = 'true';
          content.style.height = currentFullHeight + 'px';
          content.classList.remove('is-collapsed');
          content.classList.add('is-expanded');
          button.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
          if (textNode) textNode.textContent = showLessText;
        }
      });

      button.dataset.readmoreBound = 'true';
    }

    accordionItems.forEach(setupItem);
  }

  function openAccordionItem(item, panel, toggle) {
    item.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');

    panel.style.height = '0px';
    panel.offsetHeight;

    requestAnimationFrame(function () {
      panel.style.height = panel.scrollHeight + 'px';
    });

    const onTransitionEnd = function (event) {
      if (event.propertyName !== 'height') return;

      if (item.classList.contains('is-open')) {
        panel.style.height = 'auto';
      }

      panel.removeEventListener('transitionend', onTransitionEnd);

      setTimeout(function () {
        initAccordionReadMore(item.closest('[data-pdp-accordion]') || document);
      }, 50);
    };

    panel.addEventListener('transitionend', onTransitionEnd);
  }

  function closeAccordionItem(item, panel, toggle) {
    const currentHeight = panel.scrollHeight;

    panel.style.height = currentHeight + 'px';
    panel.offsetHeight;

    requestAnimationFrame(function () {
      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.style.height = '0px';
    });
  }

  function initAccordion(scope = document) {
    const accordions = scope.querySelectorAll('[data-pdp-accordion]');
    if (!accordions.length) return;

    accordions.forEach(function (accordion) {
      const items = accordion.querySelectorAll('[data-acc-item]');

      items.forEach(function (item) {
        const toggle = item.querySelector('[data-acc-toggle]');
        const panel = item.querySelector('[data-acc-panel]');

        if (!toggle || !panel) return;
        if (item.dataset.accordionBound === 'true') return;

        const isOpenInitially = item.classList.contains('is-open');
        toggle.setAttribute('aria-expanded', String(isOpenInitially));
        panel.style.height = isOpenInitially ? 'auto' : '0px';

        toggle.addEventListener('click', function () {
          const isOpen = item.classList.contains('is-open');

          if (isOpen) {
            closeAccordionItem(item, panel, toggle);
          } else {
            openAccordionItem(item, panel, toggle);
          }
        });

        item.dataset.accordionBound = 'true';
      });
    });
  }

  function initPdpAccordions(scope = document) {
    initAccordion(scope);
    initAccordionReadMore(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPdpAccordions(document);
    });
  } else {
    initPdpAccordions(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initPdpAccordions(event.target || document);
  });

  document.addEventListener('product:rerender', function () {
    initPdpAccordions(document);
  });

  document.addEventListener('variantUpdated:reinitBuybox', function () {
    initPdpAccordions(document);
  });

  function openPdpAccordionById(id) {
    if (!id) return null;

    const item = document.getElementById(id);
    if (!item) return null;

    const toggle = item.querySelector('[data-acc-toggle]');
    const panel = item.querySelector('[data-acc-panel]');

    if (!toggle || !panel) return item;

    const isOpen = item.classList.contains('is-open');

    if (!isOpen) {
      openAccordionItem(item, panel, toggle);
    }

    return item;
  }

  window.initPdpAccordions = initPdpAccordions;
  window.openPdpAccordionById = openPdpAccordionById;
})();